import { observer } from "mobx-react";
import { Switch, Redirect, Route } from "react-router-dom";
import { PrivateRoute } from "../../components/PrivateRoute";
import { Login } from "../Login";
import { StripeSuccess } from "../Stripe/StripeSuccess";
import { ClientLayout } from "../ClientLayout";
import { AdminLayout } from "../AdminLayout";
import { Stripe } from "../Stripe";
import { LostPassword } from "../LostPassword";
import { ChangePassword } from "../ChangePassword";
import { SignUp } from "../SignUp";
import { RedirectToUserBoard } from "../RedirectToUserBoard";
import useGaTracker from "../../hooks/useGaTracker";
import { useStores } from "../../hooks/useStores";

export const Navigation = observer(() => {
  useGaTracker();
  const { session } = useStores();

  return (
    <Switch>
      {/* <Sidebar /> */}
      <Route exact path={`/`} component={RedirectToUserBoard} />
      <Route path={"/login"} component={Login} />
      <Route path={"/lost-password"} component={LostPassword} />
      <Route path={"/change-password"} component={ChangePassword} />
      <Route path={"/sign-up"} component={SignUp} />

      {/* STRIPE TEST ROUTE */}
      <Route path={"/stripe"} component={Stripe} />
      <Route path={"/stripe-checkout-success"} component={StripeSuccess} />

      <PrivateRoute
        path={"/admin"}
        component={AdminLayout}
        isAuthenticated={session.isLogged}
      />
      <PrivateRoute
        path={"/client"}
        component={ClientLayout}
        isAuthenticated={session.isLogged}
      />
      <Redirect to="/login" />
    </Switch>
  );
});
